module.exports = __webpack_public_path__ + "img/pix_qr.d9e9a12.png";